//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';
import _ from 'underscore';

import DateString from '@models/DateString';
import { NormalizedScheduledTweets } from '@twitter/redux/schedule/twitterScheduleModel';
import { isDefined } from '@utils/filterPredicates';
import { mergeObjects } from '@utils/mergeObjects';

/**
 * Merges a list of normalized scheduled tweets together and re-sorts the ordered ids by scheduled time ascending.
 */
export const mergeScheduledTweetLists = (
  scheduledItemLists: NormalizedScheduledTweets[],
): NormalizedScheduledTweets => {
  const mergedById = mergeObjects(scheduledItemLists.map((scheduledItems) => scheduledItems.byId));
  const mergedItems = PojoMap.values(mergedById).filter(isDefined);

  const mergedOrderedIds = _.sortBy(mergedItems, 'scheduledTime').map((item) => item.id);

  return {
    byId: mergedById,
    orderedIds: mergedOrderedIds,
  };
};

/**
 * Fetch posts from two weeks prior to the start date so that posts are already loaded when navigating back
 * to see recent items.
 */
export const getTweetFetchStartDate = (startDate: DateString) => DateString.addDays(startDate, -14);
